import { render, staticRenderFns } from "./Musica.vue?vue&type=template&id=a4e15d1a&"
import script from "./Musica.vue?vue&type=script&lang=js&"
export * from "./Musica.vue?vue&type=script&lang=js&"
import style0 from "./Musica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports